module.exports = __webpack_public_path__ + "media/images/idealvisa-49f34108fe36c50bb3d5cdc2dba797f3.png";